import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWarningMessage } from "../Redux/Action";

function WarningMessage() {
    const dispatch = useDispatch();
    const { warningMessage } = useSelector((state) => state.data);
    useEffect(() => {
        dispatch(getWarningMessage());
    }, [dispatch]);
    if (!warningMessage || warningMessage?.showMessage === false) {
		return <></>;
	}
    return (
        <div className={`relative p-2 my-5 min-h-[${warningMessage?.height}] bg-primary`}>
            <span className={`text-[${warningMessage?.fontSize}] text-white font-semibold my-auto`}>{warningMessage?.message}</span>
        </div>
    );
}

export default WarningMessage;
